import React from "react";

/**
 * คำบรรยายใต้ปุ่มรอบ — ชื่อรอบ + ช่วงวันรับสมัครจริงจากหลังบ้าน
 * ใช้กับหน้าที่รูปปุ่มยังเป็นภาพชั่วคราว (วันในภาพอาจไม่ตรงกับรอบนั้น)
 */
function RoundCaption({ round }) {
  return (
    <>
      <span className="reg-round__name">{round.robName || round.label}</span>
      {round.startdate && round.stopdate ? (
        <span className="reg-round__date">
          {round.startdate} - {round.stopdate}
        </span>
      ) : null}
      {round.open ? null : <span className="reg-round__closed">ปิดรับสมัคร</span>}
    </>
  );
}

export default RoundCaption;
